import Axios from 'axios'
import {volunteerUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_volunteers (context) {
    Axios.get(volunteerUrls.getAllVolunteers).then(function (response) {
      context.commit('GET_ALL_VOLUNTEERS', response.data)
    })
  },
  get_volunteers (context, publicId) {
    Axios.get(volunteerUrls.getVolunteers + publicId).then(function (response) {
      context.commit('GET_VOLUNTEERS', response.data)
    })
  },
  get_deleted_volunteers (context) {
    Axios.get(volunteerUrls.getDeletedVolunteer).then(function (response) {
      context.commit('GET_DELETED_VOLUNTEERS', response.data)
    })
  },
  get_volunteer (context, publicId) {
    Axios.get(volunteerUrls.getVolunteer + publicId).then(function (response) {
      context.commit('GET_VOLUNTEER', response.data)
    })
  },
  post_volunteer (context, data) {
    Axios.post(volunteerUrls.postVolunteer, data).then(function (response) {
      router.push({
        name: 'ProgramPayment',
        params: {
          program_id: response.data.volunteer_public_id
        }
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  remind_volunteer_of_payment (context, data) {
    Axios.post(volunteerUrls.remindVolunteerPayment, data).then(function (response) {
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
     
    })
  },
  update_volunteer (context, data) {
    Axios.post(volunteerUrls.editVolunteer, data).then(function () {
      context.dispatch('get_all_volunteers')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  delete_volunteer (context, publicId) {
    Axios.get(volunteerUrls.deleteVolunteer + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_VOLUNTEERS', response.data)
      router.push({
        name: 'Module.DeletedVolunteers'
      })
    })
  },
  restoreVolunteer (context, publicId) {
    Axios.get(volunteerUrls.restoreVolunteer + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VOLUNTEERS', response.data)
      router.push({
        name: 'Module.Volunteers'
      })
    })
  }
}
